import { BaseAndCrudRoutes } from '@monorepo/tools/src/lib/routes/base.routes';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export class AdvertisersRoutes extends BaseAndCrudRoutes {
	constructor() {
		super('advertisers');
	}

	overview(id: id) {
		return `/${this.baseRoute}/${id}/overview`;
	}

	campaigns(id: id) {
		return `/${this.baseRoute}/${id}/campaigns`;
	}

	// landing pages
	pages(id: id) {
		return `/${this.baseRoute}/${id}/pages`;
	}

	activityLog(id: id) {
		return `/${this.baseRoute}/${id}/activity-log`;
	}

	settings(id: id) {
		return `/${this.baseRoute}/${id}/settings`;
	}

	channels(id: id) {
		return `/${this.baseRoute}/${id}/channels`;
	}

	sources(id: id) {
		return `/${this.baseRoute}/${id}/sources`;
	}

	createCampaign(id: id) {
		return `/${this.baseRoute}/${id}/campaigns/create`;
	}
}
